export default __webpack_public_path__ + "static/media/element_85.6b4ee9ef.jpg";